import Grid from "@material-ui/core/Grid";
import React from "react";
import { FlyerDetailPageTabPageDetailsTemplateProps } from "./flyer-detail-page-tab-page-details-template.props";

export const FlyerDetailPageTabPageDetailsTemplate = (
  props: FlyerDetailPageTabPageDetailsTemplateProps
) => (
  <Grid item={true} xs={2} sm={2} md={2} lg={2}>
    {props.templateName}
  </Grid>
);
